import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a9b9a85"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Signup Form", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Cadastrar")

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useLoading } from '@/composables'
import { AlertNotification } from '@/components'
import { FormAuth } from '@/@types'
import AuthModeLink from './AuthModeLink.vue'
import useSignup from '../composables/useSignup'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isPending, notification, signup, supabaseSignup } = useSignup()
const router = useRouter()
const { overlayLoading } = useLoading()
const formData = ref<FormAuth>({
  displayName: '',
  email: '',
  password: '',
  passwordConfirm: ''
})

watch(
  () => isPending.value,
  () => {
    overlayLoading(isPending.value)
  }
)
const handleSubmit = async () => {
  // await signup(formData.value)
  await supabaseSignup(formData.value)
  if (!notification.value.error) router.push({ name: 'Profile' })
}

return (_ctx: any,_cache: any) => {
  const _component_AppTextfield = _resolveComponent("AppTextfield")!
  const _component_app_btn = _resolveComponent("app-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(handleSubmit, ["prevent"])
    }, [
      _hoisted_2,
      _createVNode(_component_AppTextfield, {
        placeholder: "Nome",
        modelValue: formData.value.displayName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.displayName) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppTextfield, {
        placeholder: "Email",
        modelValue: formData.value.email,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppTextfield, {
        placeholder: "Senha",
        modelValue: formData.value.password,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.password) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_AppTextfield, {
        placeholder: "Repita a Senha",
        modelValue: formData.value.passwordConfirm,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.passwordConfirm) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_3,
      _createVNode(_component_app_btn, null, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ], 40, _hoisted_1),
    _createElementVNode("div", null, [
      _createVNode(AuthModeLink, {
        text: "Já é cadastrado?",
        textLink: "Acesse o sistema",
        to: { name: 'Welcome', params: { mode: 'login' } }
      }),
      _createVNode(AuthModeLink, {
        text: "Esqueceu a senha?",
        textLink: "Redefina",
        to: { name: 'Welcome', params: { mode: 'reset' } }
      })
    ]),
    (_unref(notification).type)
      ? (_openBlock(), _createBlock(_unref(AlertNotification), {
          key: 0,
          message: _unref(notification).message,
          type: _unref(notification).type
        }, null, 8, ["message", "type"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})